<template lang="html">
  <modal
    name="edit-post-modal"
    height="auto" width="1000" :adaptive="true"
    class="edit-article-modal"
    @before-open="beforeOpen"
  >
    <FullScreenProgress :progress="progress" :max="100" />
    <div class="modal-container">
      <div class="modal-header">
        {{headerText}}
      </div>
      <div class="line-break">

      </div>
      <div class="modal-body">
        <div class="bold">Status</div>
        <select v-model="article.status" class="select" :disabled="config.disabled">
          <option v-for="status in article.statuses" :value="status" :key="status">
            {{status}}
          </option>
        </select>
        <div class="gap-3x"></div>

        <div class="bold">Subject</div>
        <div class="gap-1x"></div>
        <InputWithErrorV2
          v-bind:value.sync="article.subject"
          placeholder="Subject"
          :error="errors.subject"
        />
        <div class="gap-3x"></div>

        <div class="bold">Page Title</div>
        <InputWithErrorV2
          v-bind:value.sync="article.data.metaTitle"
          placeholder="Title of Blog Page"
          :error="errors.metaTitle"
        />
        <div class="gap-2x"></div>

        <div class="bold">Meta Keywords</div>
        <input v-model="article.data.metaKeywords" placeholder="Meta Keywords" />
        <div class="gap-2x"></div>

        <div class="bold">Meta Description</div>
        <InputWithErrorV2
          v-bind:value.sync="article.data.metaDescription"
          placeholder="Meta Description"
          :error="errors.metaDescription"
        />
        <div class="gap-2x"></div>

        <div class="bold">Text Body</div>
        <textarea v-model="article.data.textBody" placeholder="Text body for article" />
        <div class="gap-2x"></div>

        <div class="bold">Main Content</div>
        <ckeditor :editor="editor" v-model="article.content_html" :config="editorConfig" />
        <div class="gap-2x"></div>

        <div class="bold med-text">
          Cover Image
        </div>
        <img :src="article.data.coverURL" height="300" v-if="article.data.coverURL" />
        <div class="error-message" v-if="!article.data.coverURL">Required</div>
        <div class="gap-2x" />
        <label for="uploadCover">
          <SymbiumButton
            text="Add Cover"
            :isSmall="true"
            :onClick="uploadCover"
          />
          <input type="file" id="uploadCover" style="display:none" @change="processCover">
        </label>
        <div class="gap-2x"></div>
        <div class="bold">Cover Image Caption</div>
        <div class="gap-1x" />
        <div class="cover-caption-editor">
          <ckeditor :editor="editor" v-model="article.data.coverCaption" :config="editorConfig" />
        </div>
        <div class="gap-2x"></div>
        <div class="bold">Cover Image Alt Text</div>
        <div class="gap-1x" />
        <InputWithErrorV2
          v-bind:value.sync="article.data.coverAltText"
          placeholder="Cover Image Alt Text"
          :error="errors.coverAltText"
        />
        <div class="gap-3x"></div>
        <div class="bold">Blog URL</div>
        <input v-model="article.data.postExternalUrl" placeholder="URL to article" />

        <div class="gap-3x"></div>
        <div class="bold">videoTemplate</div>
        <input v-model="article.data.videoTemplate" placeholder="Video url" />

        <div class="gap-3x"></div>
        <div class="bold">Date</div>
        <input v-model="article.data.date" placeholder="Date shown to reader" />

        <div class="gap-3x"></div>
        <SymbiumButton
          v-if="article.id"
          text="Delete this article"
          :onClick="emitDestroy"
          :isSmall="true"
          :isPrimary="true"
        />
        <div class="gap-3x"></div>
      </div>
      <div class="line-break" />
      <ModalFooter
        :save="save"
        :cancel="() => $modal.hide('edit-post-modal')"
        :rightActionLoading="loading"
      />
    </div>
  </modal>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2';

import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import InputWithErrorV2 from 'src/components/common/InputWithErrorV2.vue'
import ModalFooter from 'src/components/common/modals/shares/ModalFooter.vue'
import DisableBodyScroll from 'src/mixins/DisableBodyScroll.js'
import FileUploadProgress from 'src/mixins/FileUploadProgress.js'
import FullScreenProgress from 'src/components/common/FullScreenProgress.vue'

import CkImageUploadAdapter from 'src/plugins/CkImageUploadAdapter.js'
import { processImage } from 'src/plugins/ImageOptimizer.js'

import EditArticle from '../mixins/EditArticle.js'

export default {
  components: {
    ModalFooter, SymbiumButton, FullScreenProgress, InputWithErrorV2,
    ckeditor: CKEditor.component
  },
  mixins: [DisableBodyScroll, FileUploadProgress, EditArticle],
  data() {
    return {
      types: ['business', 'government'],
      editorConfig: {'extraPlugins': [CkImageUploadAdapter] }
    }
  },
  computed: {
    headerText() {
      return this.article.type
    }
  },
  methods: {
    processCover(event) {
      var reader = new window.FileReader();
      reader.addEventListener('load', () => {
        processImage(reader.result, (data) => {
          this.article.data.coverURL = data
          this.$forceUpdate()
          this.$article.uploadImage(data).then(
            (response) => { this.article.data.coverURL = response.data.url; },
            () => alert('Something went wrong. Please try again')
          )
        }, 1200)
      });
      reader.readAsArrayBuffer(event.target.files[0]);
    },
    uploadCover() {
      document.querySelector('#uploadCover').click()
    }
  },
  watch: {
    article: {
      handler(val) {
        ["subject", "metaTitle", "metaDescription", "coverAltText", "coverURL"].map((attr) => {
          this.errors[attr] = !val[attr] && !val.data[attr] ? "Required" : null
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.modal-body {
  input, select, textarea {
    width: 100%;
  }

  textarea {
    min-height: 150px;
  }
}

.edit-article-modal {
  .modal-body {
    max-height: calc(100vh - 192px) !important;
  }
}

.ck-balloon-panel{
  z-index: 999999 !important;
}
</style>
